import { render, staticRenderFns } from "./comments-component.vue?vue&type=template&id=323d7c7a&scoped=true&"
import script from "./comments-component.vue?vue&type=script&lang=js&"
export * from "./comments-component.vue?vue&type=script&lang=js&"
import style0 from "./comments-component.vue?vue&type=style&index=0&id=323d7c7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d7c7a",
  null
  
)

export default component.exports